import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesCms {
  ler: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `cms`
 * (`apps/api/src/modules/cms/pagina.routes.ts`, seed original da
 * migration `004`): `admin` (curinga `*`) tem tudo; `marketing` só
 * `ler` ("leitura ao CMS para campanhas específicas", `PRODUCT.md` 4.6).
 */
export function permissoesCms(papel: PapelUsuario): PermissoesCms {
  if (papel === 'admin') return { ler: true, atualizar: true };
  if (papel === 'marketing') return { ler: true, atualizar: false };
  return { ler: false, atualizar: false };
}
